import axios from "axios";
import { api } from "./api";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Or AsyncStorage for mobile
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const StudentAdmission = async (data) => {
  return await api.post(`/new/student`, data);
};

export const FeesImportStudent = async (data) => {
  return await api.post(`/student/import/fees`, data);
};

export const GetRegNo = async (addUrl = "") => {
  let url = `student/registration_no?${addUrl}`;
  return await api.get(url);
};

export const StudentList = async (addUrl = "") => {
  let url = `get/students/list?${addUrl}`;
  return await api.get(url);
};
export const StudentListAll = async (addUrl = "") => {
  let url = `get/students/list/all?${addUrl}`;
  return await api.get(url);
};
export const StudentListProfilePost = async (data) => {
  return await api.post(`/students/Profile_pic_update`, data);
};
export const StudentListProfile = async (addUrl = "") => {
  let url = `get/students/list/profileUpdate?${addUrl}`;
  return await api.get(url);
};
export const StudentListt = async (addUrl = "") => {
  let url = `test/onley/student?${addUrl}`;
  return await api.get(url);
};
export const student = async (addUrl = "") => {
  let url = `get/students/list?${addUrl}`;
  return await api.get(url);
};

export const StudentInfo = async (id) => {
  return await api.get(`student/info/${id}`);
};
export const StudentReview = async (id) => {
  return await api.get(`student/review?student_id=${id}`);
};
export const StudentTestData = async (student_id) => {
  return await api.get(
    `test/student/profile/test/data?student_id=${student_id}`
  );
};
export const StudentCourseNFeesInfo = async (id) => {
  return await api.get(`/student/coursefees/list/${id}`);
};

export const StudentInfoAttendence = async (id, month) => {
  return await api.get(`student/info/${id}?&month=${month}`);
};
export const StudentInfoAttendenceCalender = async (studentId, month) => {
  return await api.get(
    `attendance/student/calendar/data?student_id=${studentId}&month=${month}`
  );
};
export const StudentInfoAttendenceDate = async (studentId, date) => {
  return await api.get(
    `attendance/student/date/list?student_id=${studentId}&date=${date}`
  );
};
export const Course_n_feesInfo = async (id) => {
  return await api.get(`/student/coursefees/list/${id}`);
};

export const studentUpdate = async (data) => {
  return await api.post(`/student/profile/update`, data);
};

export const UpdateStudentDocument = async (data) => {
  return await api.post(`student/documents/update`, data);
};

export const UpdateStudentDiscount = async (data) => {
  return await api.post(`student/fee_discount`, data);
};

export const ReceiptInfo = async (id) => {
  return await api.get(`student/fees/receipt/info?id=${id}`);
};
export const BatchStudent = async (addUrl = ``) => {
  let url = `/student/search?${addUrl}`;
  return await api.get(url);
};
export const StudentBatchAdmission = async (data) => {
  return await api.post(`/student/new/batch/add`, data);
};
export const StudentBatchTransfer = async (data) => {
  return await api.post(`/student/batch/change/v4`, data);
};
export const StudentReciptDelete = async (payload) => {
  return await api.post(`/student/transactions/delete/v4`, payload);
};

export const studentDashboardReport = async (addUrl = ``) => {
  let url = `/student/dashboard/report?${addUrl}`;
  return await api.get(url);
};
export const studentDashboardReportV4 = async (addUrl = ``) => {
  let url = `/student/dashboard/report/v4?${addUrl}`;
  return await api.get(url);
};
